'use strict';

/**
 * Google Analytics events module
 *
 * @description Defines click events and pushes them to GTM dataLayer.
 * @class Analytics
 */
class Analytics {

  constructor(){
    this.tsEl = document.querySelector('.ticket-selector');
    this.eventName = this.tsEl ? this.tsEl.getAttribute('data-event-name') : '';
    this.eventPayloadName = `Lippuvalitsin${ this.eventName ? ' - ' + this.eventName : '' }`;
    this.tsElWidth = this.tsEl && this.tsEl.offsetWidth > 767 ? 'Wide' : this.tsEl ? 'Narrow' : '';
    this.payload = {
      event: 'GAevent',
      eventCategory: this.eventPayloadName,
      eventLabel: this.tsElWidth
    };
    this.categories = {
      // Category name: category's container css-selector
      'Entrance':  '.catalog-items__section.main',
      'Programme': '.catalog-items__section.program',
      'Extra':    '.catalog-items__section.extra',
      'Other':     '.catalog-items__section.other',
      'Summary':   '.ts-summary'
    };
    this.buttonSelectors = {
      plus: {
        actionName: 'Add %CAT% Ticket',
        elClass: '.catalog-items__button.button-plus'
      },
      minus: {
        actionName: 'Remove %CAT% Ticket',
        elClass: '.catalog-items__button.button-minus'
      },
      select: {
        actionName: 'Add Multiple %CAT% Tickets',
        elClass: '.catalog-items__select'
      },
      moreLess: {
        actionName: 'Show %CAT% Tickets',
        elClass: '.catalog-items__section-item-list-toggle'
      },
      programGroupMoreLess: {
        actionName: 'Select Show Tickets',
        elClass: '.catalog-items__group .button.toggler'
      },
      showSummary: {
        actionName: 'Show summary',
        elClass: '.ts-summary-float__link a'
      },
      summaryRemove: {
        actionName: 'Remove tickets from %CAT%',
        elClass: '.ts-summary .remove-cart-item'
      },
      summaryProceed: {
        actionName: 'Buy Tickets',
        elClass: '.ts-summary__foot-cart-btn',
        preventDefault: true,
        callback: function( event ){
          const linkEl = event.target.closest('.ts-summary__foot-cart-btn');
          const href = linkEl ? linkEl.getAttribute('href') : '';

          // Note: window.top.location, since we may be operating inside iframe
          if( href ) window.top.location.href = href;

        }
      },
    };
  }

  /**
   * Attach DOM events
   * @memberof Analytics
   */
  attachDomEvents(){

    const parent = this;
    const cats = this.categories;
    const buttonTypes = this.buttonSelectors;

    let preventDefault = false;
    let callback;

    const clickFunction = function(event){

      let categoryName;
      let eventName;

      for( const cat in cats ){
        const catEl = event.target.closest(cats[cat]);
        if( catEl ){
          categoryName = cat;
          break;
        }
      }

      if( categoryName ){
        for( const buttonType in buttonTypes ){
          const targetEl = event.target.closest( buttonTypes[buttonType].elClass );
          if( targetEl ){
            eventName = buttonTypes[buttonType].actionName.replace('%CAT%',categoryName);
            preventDefault = buttonTypes[buttonType].preventDefault || false;
            callback = buttonTypes[buttonType].callback;
            break;
          }
        }

        if( eventName ) parent.pushToDataLayer( Object.assign({},parent.payload,{eventAction: eventName}) );
        if( preventDefault ){
          event.preventDefault();
        }
        if( callback ){
          callback( event );
        }

      }

      return false;

    } // end clickFunction

    const bodyClick = function(event){
      Object.keys(buttonTypes).forEach(function(btnType){
        if( event.target.closest(buttonTypes[btnType].elClass) ){
          clickFunction( event );
        }
      });
    };

    // one click to rule them all!
    document.body.addEventListener('click', bodyClick );

    // paymenyt method change to eCom events
    const paymentMethodChange = ( event ) => {
      const target = event ? event.target : null;
      if( target && target.className && target.className.includes('stage-payment-provider')){
        const name = target.getAttribute('data-name') || '';
        const value = target.value;
        const data = {
          'event': 'eec.checkoutOption',
          'ecommerce': {
            'checkout_option': {
              'actionField': {'step': 3, 'option': `${name} (${value})`}
            }
          }
        };

        this.pushToDataLayer( data );
      }
    }

    const pmForm = document.getElementById('payment-method-form');
    if( pmForm ){
      // one click to rule them all!
      document.body.addEventListener('change', paymentMethodChange );
    }

  } // attachDomEvents


  /**
   * Payment method change - Create a eCom event object and push it to dataLayer
   * @param {object} event - DOM change event
   */



  /**
   * Push object to GTM dataLayer
   *
   * @param {object} eventObject - object to be pushed to window.dataLayer
   * @returns {boolean} - true if successful, else fail
   * @memberof Analytics
   */
  pushToDataLayer( eventObject ){
    if( window.dataLayer && eventObject ){
      window.dataLayer.push( eventObject );
      return true;
    }
    return false;
  }

  /**
   *
   * @param {object|array} impressions - Impression objects to be included to impressionEvent
   * @param {object} [actionField={list: 'Ticket selector'}] - actionField to be included
   * @param {string} [currencyCode='EUR'] - Currency Code
   * @returns {object} null if input parameter failed, else an impression object ready for datalayer.push
   */
  createImpressionEvent( impressions, actionField = {list: 'Ticket selector'}, currencyCode = 'EUR' ){
    if(
      !impressions ||
      !impressions.length ||
      !actionField ||
      !currencyCode ) return null;

    return {
      event: 'eec.impressionView', // note: custom `eec.` prefix
      ecommerce: {
        currencyCode: currencyCode,
        actionField: actionField,
        impressions: impressions
      }
    };
  }

  /**
   * Create eCommerce event objects from cart actions and push to dataLayer.
   * @param {object|array} actionsArr - Array of action objects from cart
   * @returns {boolean} - success as boolean
   */
  processCartActions( actionsArr ){
    if( !actionsArr || actionsArr instanceof Array === false ){
      console.warn('processCartActions() failed, invalid input value');
      return false;
    }

    for( const actionObj of actionsArr){
      const type = actionObj.action;
      switch (type) {
      case 'add':
        this.pushToDataLayer({
          'event': 'eec.addToCart', // note: custom `eec.` prefix
          'ecommerce': {
            'currencyCode': 'EUR',
            'add': { // 'add' actionFieldObject measures.
              'products': [{ //  adding a product to a shopping cart.
                'name': actionObj.name,
                'id': actionObj.id,
                'price': actionObj.price,
                'brand': actionObj.brand,
                'category': actionObj.category,
                'variant': actionObj.variant || null,
                'quantity': actionObj.amount,
              }]
            }
          }
        });
        break;

      case 'remove':
        this.pushToDataLayer({
          'event': 'eec.removeFromCart', // note: custom `eec.` prefix
          'ecommerce': {
            'remove': { // 'remove' actionFieldObject measures.
              'products': [{ //  removing a product to a shopping cart.
                'name': actionObj.name,
                'id': actionObj.id,
                'price': actionObj.price,
                'brand': actionObj.brand,
                'category': actionObj.category,
                'variant': actionObj.variant || null,
                'quantity': actionObj.amount,
              }]
            }
          }
        });
        break;

      }
    }

    return true;

  }

  /**
   * Initialize analytics module
   */
  init(){
    console.log('analytics.init()');
    if( window.dataLayer ) this.attachDomEvents();
  }
}

export default new Analytics();
